{
    "GenericModal_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "GenericModal_PromptConfirm": "Sim",
    "GenericModal_PromptCancel": "Cancelar",
    "NAME": "GenericModal"
}